import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { ModalBuatPinComponent } from '../../components/modal-buat-pin/modal-buat-pin.component';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/api/user.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { PinModel } from 'src/app/models/pin.model';
import { MaintenanceComponent } from 'src/app/modules/shared/components/maintenance/maintenance.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BypassApiService } from 'src/app/services/api/bypass.service';
import { ProfileService } from 'src/app/services/profile.service';
import { ResponseCustomType } from 'src/app/types/response/response.type';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';

@Component({
  standalone: false,
  selector: 'app-pin',
  templateUrl: './pin.component.html',
  styleUrls: ['./pin.component.scss']
})
export class PinComponent implements OnInit {
  @Input() pin!: PinModel
  @ViewChild('changePIN', { static: false }) changePINModal: any;

  settings: any = {
    length: 6,
    numbersOnly: true,
  };
  isDisabled: boolean = true;
  isErrorMessage: boolean = false;
  @Input() otpParams: any = {
    pin: '',
  };
  otp: string = '';
  destroy$ = new Subject()
  loading: boolean = true;
  pinStatus: boolean = false;

  private profileSubscription!: Subscription;
  isEnterprise: boolean = false;

  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    private userService: UserService,
    private toastService: ToastService,
    private byPassService: BypassApiService,
    private profileService: ProfileService,
    private message: NzMessageService,
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }
  ngOnInit(): void {
    this.getProfile()
    setTimeout(() => {
      this.loading = false
    }, 1000)
  }

  getProfile() {
    this.profileSubscription = this.profileService.profileData$.subscribe((data) => {
      if (data) {
        this.pinStatus = data.pin_status ?? false
        this.isEnterprise = data.rajaongkir_level === 3;
      }
    });
  }

  open(m: any) {
    this.modalService.open(m, { centered: true });
  }
  close(value: any) {
    this.modalService.dismissAll(value);
    this.isErrorMessage = false;
  }
  changePIN(changePIN: any) {
    this.modalService.open(changePIN, { centered: true });
  }

  lupaPinClik(e: Event): void {
    const modal = this.modalService.open(MaintenanceComponent, {
      centered: true,
      backdrop: "static"
    })
  }
  buatPinClik(e: Event): void {
    const modal = this.modalService.open(ModalBuatPinComponent, {
      centered: true,
      backdrop: "static"
    })
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.code === 'Backspace') {
      this.isErrorMessage = false;
      this.isDisabled = true;
    }
  }

  onChange(e: string) {
    this.otp = e;
    if (e.length === 6) {
      this.isDisabled = false;
    }
  }

  handleConfirm() {
    this.otpParams.pin = this.otp
    this.byPassService
      .request<ResponseCustomType<PinModel>>({
        method: 'POST',
        endpoint: `${environment.SWITCH_URL}/user/api/v1/user/check-pin`,
        body: this.otpParams
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: ResponseCustomType<PinModel>) => {
          if (res.data.is_match === true) {
            this.pin = res.data
            this.openModal(this.changePINModal)
          } else {
            this.isErrorMessage = true
          }
        },
        error: (err: HttpErrorResponse) => {
          this.loading = false;
          this.message.create('error', err.error.meta.message);
        }
      });
  }

  handleUpdate(e: any) {
    this.otpParams.pin = this.otp
    if (this.isEnterprise) {
      this.userService
        .updatePin(this.otpParams)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
            this.pin = res.data
            this.toastService.show(null, 'Successfully Changed PIN', 'success', {
              classname: 'bg-success',
              delay: 5000,
            });
            this.modalService.dismissAll(e);
        }, (err) => {
          this.loading = false;
          this.message.create('error', err.error.meta.message);
        })
    } else {
      this.byPassService
        .request<any>({
          method: 'PUT',
          endpoint: `${environment.SWITCH_URL}/user/api/v1/user/update-pin`,
          body: this.otpParams
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: ResponseCustomType<any>) => {
            this.pin = res.data
            this.toastService.show(null, 'Successfully Changed PIN', 'success', {
              classname: 'bg-success',
              delay: 5000,
            });
            this.modalService.dismissAll(e);
          },
          error: (err) => {
            this.loading = false;
            this.message.create('error', err.error.meta.message);
          }
        });
    }
  }
  handleCreate(e: any) {
    this.otpParams.pin = this.otp
    if (this.isEnterprise) {
      this.userService
        .updatePin(this.otpParams)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
            this.pin = res.data
            this.toastService.show(null, 'Successfully Created PIN', 'success', {
              classname: 'bg-success',
              delay: 5000,
            });
            this.modalService.dismissAll(e);
            window.location.reload()
        }, (err) => {
          this.loading = false;
          this.message.create('error', err.error.meta.message);
        })
    } else {
      this.byPassService
        .request<any>({
          method: 'PUT',
          endpoint: `${environment.SWITCH_URL}/user/api/v1/user/update-pin`,
          body: this.otpParams
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: ResponseCustomType<any>) => {
            this.pin = res.data
            this.toastService.show(null, 'Successfully Created PIN', 'success', {
              classname: 'bg-success',
              delay: 5000,
            });
            this.modalService.dismissAll(e);
            window.location.reload()
          },
          error: (err) => {
            this.loading = false;
            this.message.create('error', err.error.meta.message);
          }
        });
    }
  }
  openModal(changePIN: any) {
    this.modalService.open(changePIN, { centered: true });
  }

  ngOnDestroy(): void {
    this.destroy$.unsubscribe();
  }
}
